const config = {
  SERVER_IP: process.env.REACT_APP_SERVER_IP,
  API_PORT: process.env.REACT_APP_API_PORT,
  APP_PORT: process.env.REACT_APP_APP_PORT,

  get BASE_URL() {
    if (!this.SERVER_IP || !this.API_PORT) {
      throw new Error("Missing SERVER_IP or API_PORT in .env file!");
    }
    return `http://${this.SERVER_IP}:${this.API_PORT}`;
  },

  get PORT_URL() {
    if (!this.SERVER_IP || !this.APP_PORT) {
      throw new Error("Missing SERVER_IP or APP_PORT in .env file!");
    }
    return `http://${this.SERVER_IP}:${this.APP_PORT}`;
  },
};

const configmain = {
  SERVER_IP: process.env.REACT_APP_SERVER_IP,
  SERVER_PORT: process.env.REACT_APP_SERVER_PORT,

  get BASE_URL() {
    if (!this.SERVER_IP || !this.SERVER_PORT) {
      throw new Error("Missing SERVER_IP or SERVER_PORT in .env file!");
    }
    return `http://${this.SERVER_IP}:${this.SERVER_PORT}`;
  },
};

// Export both objects using named exports
export { config, configmain };
